import BillingsTaxiDriverUpdateRequest, {
  BillingsTaxiDriverUpdateRequestBody,
} from "./billings-taxi-driver-update.request";

const createBody = (
  request: BillingsTaxiDriverUpdateRequest,
): BillingsTaxiDriverUpdateRequestBody => {
  return {
    billingContributions: request.billingContributions,
    billingNodes: request.billingNodes,
  };
};

const billingsTaxiDriverUpdateRequestFactory = {
  createBody,
};

export default billingsTaxiDriverUpdateRequestFactory;
